import styled from 'styled-components';

import StopsTooltip from './component';

export default styled(StopsTooltip)``;
